import { ADMIN_ROLE } from "./constants";
import { pathWithRedirectQuery } from "./postLoginRedirect";
import { persistor } from "../Redux/configureStore";

// Hard-navigate to the role's own sign-in (usable outside the Router, e.g.
// the idle timer and the axios interceptor). Flushes persisted state first so
// the cleared session can't lose the race against the reload.
export async function redirectToRoleSignIn(role, returnTo) {
  const path = role === ADMIN_ROLE ? "/signIn/admin" : "/signIn/doctor";
  await persistor.flush();
  window.location.replace(
    returnTo ? pathWithRedirectQuery(path, returnTo) : path
  );
}
